define('app/views/base_view',['app/setup', 'app/lib/lockr'], function(takhfifan) {

  takhfifan.BaseView = Backbone.View.extend({

    setCookie: function(options) {
      var expires = options.expires || 1;
      var name = options.name || this.cookie_closed;
      var value = options.value || true;

      $.cookie(name, value, {
        path: '/',
        domain: '.' + document.domain,
        expires: expires
      });
    },

    renderErrors: function(errors) {
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var $li = $('<li></li>');
        $li.html(e);
        $errors.append($li);
      });
      $errors.show();
    },

    urlParam: function(name){
      var regex = new RegExp('[\?&]' + name + '=([^&#]*)');
      var results = regex.exec(window.location.href);

      if (_.isNull(results)){
        return null;
      }

      return results[1] || 0;
    },

    magentoUrlEncode: function(s) {
      return btoa(s)
        .replace(/\+/g,'-')
        .replace(/\//g,'_')
        .replace(/=/g, ',');
    },

    addToCartUrl: function(productId) {
      var urlPart = window.location.origin + '/ajax/product/elements/i/' +  productId;

      return window.location.origin + '/checkout/cart/add' +
        '/uenc/' + this.magentoUrlEncode(urlPart) +
        '/product/' + productId +
        '/form_key/' + takhfifan.formKey;
    },

    setResetSessionFlag: function(){
      if(window.Lockr){
        Lockr.set('reset', 'true');
      }
    }
  });
});

